import { render, staticRenderFns } from "./LeaveApproval.vue?vue&type=template&id=a7490fe0"
import script from "./LeaveApproval.vue?vue&type=script&lang=js"
export * from "./LeaveApproval.vue?vue&type=script&lang=js"
import style0 from "./LeaveApproval.vue?vue&type=style&index=0&id=a7490fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports